module.exports = __webpack_public_path__ + "img/crewpages_logo_text_white.aabf1002.svg";